import { httpClient } from "./httpClient";
import { store, setUserData } from "../../redux/index";
import utils from "utils";

export const apiCall = async ({ data, url, method }) => {
  return httpClient[method](url, method === "get" ? { params: data } : data)
    .then(function (res) {
      console.log("ok apicall res", res);

      res.message =
        res?.response?.data?.message || res?.data?.message || res?.message;
      return res;
    })
    .catch((error) => {
      console.log("err apicall res", error);
      if (typeof error?.response?.data === "string") {
        error.message = error?.response?.data;
      } else {
        error.message = error?.response?.data?.message || error?.message;
      }

      if (error?.response?.status === 401) {
        utils.logout({
          dispatch: store.dispatch,
          setUserData: setUserData,
        });
      }
      return error;
    });
};
